import styled from "styled-components";
import Color from "../../assets/color";

const CustomStyled = styled.div`
  /* --- 2.2 Footer --- */
  footer {
    background-color: #2d2d2d;
    padding: 35px 0 0 0;
    border: 0;

    @media (max-width: 575px) {
      padding: 1rem 0 0 0;
    }

    a,
    p {
      font-size: 15px;
      color: #808285;
      line-height: 1.5;
      font-family: "Lato Bold", sans-serif;
    }

    a {
      :hover,
      view-more:hover {
        color: ${Color.primary};
        font-weight: bold;
        text-decoration: underline;
      }
      :focus {
        color: ${Color.primary};
        text-decoration: none;
        outline: none;
      }
      &.view-more {
        color: ${Color.white};
      }
    }

    h3 {
      color: ${Color.white};
      font-size: 20px;
      font-family: "Lato Black", sans-serif;
      margin: 0 0 1rem 0;
      text-align: center;

      &.title {
        font-family: "Lato Bold Italic", sans-serif;
        width: 50%;
        line-height: 1.5em;

        span.dots {
          height: 5px;
          width: 5px;
          background-color: ${Color.white};
          border-radius: 50%;
          display: inline-block;
          vertical-align: middle;
        }
      }

      @media (max-width: 575px) {
        &.uppercase {
          text-align: center;
        }
      }
    }
    ul {
      margin: 0;
      padding: 0 0 20px;
      list-style: none;

      li.active a {
        color: ${Color.white};
        font-weight: bold;
      }

      &.navigate {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        li {
          margin-right: 1.5rem;

          @media (max-width: 575px) {
            a {
              font-size: 14px;
            }
          }
        }
      }
    }

    .logo-container {
      @media (max-width: 575px) {
        text-align: center;
      }

      .logo {
        margin-bottom: 20px;

        @media (max-width: 768px) {
          width: 120px;
          margin: auto;
          margin-bottom: 30px;
        }

        @media (max-width: 575px) {
          width: 90px;
        }
      }
    }

    .app {
      a {
        img {
          width: 100%;
          max-width: 161px;
        }
      }

      @media (max-width: 575px) {
        display: flex;
        justify-content: center;
      }
      a {
        display: block;
      }
    }
    #social_footer {
      text-align: center;
      border-top: 0;
      padding-top: 0;
      margin-top: 15px;
      margin-bottom: 15px;

      ul {
        margin: 0;
        padding: 0;
        text-align: center;

        li {
          display: inline-block;
          margin: 0 5px 10px 5px;
          a {
            text-align: center;
            line-height: 34px;
            display: block;
            font-size: 16px;
            width: 35px;
            height: 35px;

            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;

            color: #808285;
            border-radius: 50%;
            border: solid 1px;
            background-color: transparent;
            :hover {
              border-color: transparent;
              color: ${Color.white};
            }
            &.facebook:hover {
              background: #3a589d;
            }
            &.instagram:hover {
              background: #3b6994;
            }
            &.twitter:hover {
              background: #2478ba;
            }
            &.youtube:hover {
              background: #c33223;
            }
          }
        }
      }
      p {
        font-size: 12px;
        color: #8c8c8c;
      }
    }
    .copyright {
      padding: 1rem 0;
      background: ${Color.emperor};
      color: ${Color.white};
    }
  }
`;

export default CustomStyled;
